
import React from "react";
import { Button as MuiButton, Pagination } from "@mui/material";

export const renderPagination = ({ totalPages, page, handlePageChange }) => {
  const createPageButton = (pageNum) => (
    <MuiButton
      disableElevation
      key={pageNum}
      variant={page === pageNum ? "contained" : "outlined"}
      onClick={() => handlePageChange(pageNum)}
      style={getPageButtonStyle(page === pageNum)}
    >
      {pageNum}
    </MuiButton>
  );

  const getPageButtonStyle = (isActive) => ({
    margin: "0 2px",
    backgroundColor: isActive ? "black" : "transparent",
    color: isActive ? "white" : "black",
    border: isActive ? undefined : "1px solid black",
    borderRadius: "50%",
    minWidth: "40px",
    minHeight: "40px",
    fontSize: "14px",
    fontWeight: isActive ? "bold" : "normal",
    cursor: "pointer",
  });

  const getNavButtonStyle = (disabled) => ({
    backgroundColor: disabled ? "grey" : "black",
    height: "100%",
    borderRadius: "50%",
    minWidth: "40px",
    minHeight: "40px",
    fontSize: "25px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    border: `1px solid ${disabled ? "grey" : "black"}`,
    cursor: disabled ? "not-allowed" : "pointer",
    padding: "0 1vw",
  });

  const renderEllipsis = (key) => <span style={{ margin: "0 2px" }} key={key}>...</span>;

  const renderPageButtons = () => {
    let buttons = [createPageButton(1)];
    if (totalPages <= 5) {
      for (let i = 2; i <= totalPages; i++) buttons.push(createPageButton(i));
    } else {
      if (page > 3) buttons.push(renderEllipsis("ellipsis-start"));
      
      for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) {
        buttons.push(createPageButton(i));
      }
      
      if (page < totalPages - 2) buttons.push(renderEllipsis("ellipsis-end"));
      buttons.push(createPageButton(totalPages));
    }
    return buttons;
  };

  return (
    <div style={{
      marginTop: "1vh",
      marginBottom: "1vh",
      height: "7vh",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    }}>
      {page > 1 ? (
        <MuiButton disableElevation onClick={() => handlePageChange(page - 1)} style={getNavButtonStyle(page === 1)}>
          &lt;
        </MuiButton>
      ) : (<div style={{ width: "40px" }}></div>)}

      <div>{renderPageButtons()}</div>

      {page < totalPages ? (
        <MuiButton disableElevation onClick={() => handlePageChange(page + 1)} style={getNavButtonStyle(page === totalPages)}>
          &gt;
        </MuiButton>
      ) : (<div style={{ width: "40px" }}></div>)}
    </div>
  );
};

